import { PROYECTOS_DEMO } from './preview-data';

/**
 * Órdenes de venta y facturación de muestra.
 *
 * Los números **replican el caso real de SEED01 en ARMUS**, que es el que se
 * usó para validar: dos órdenes por el mismo neto, una facturada al 100% con
 * una nota de débito encima, y otra parcialmente facturada y después anulada
 * por una nota de crédito. Así la pantalla muestra los tres casos que importan
 * —completa, con excedente, y anulada— sin tener que inventarlos.
 */
const ORDENES = [
  {
    id: 1, armus_id: 501, numero: 'S00087', fecha_pedido: '2026-09-01',
    moneda: 'USD', monto_total: 68739.18, monto_neto: 56809.24,
    monto_original: 85941118.52, moneda_original: 'ARS',
    cliente: 'ACME SA', estado: 'sale',
    oportunidad_codigo: '118', oportunidad_nombre: 'Venta inicial',
    /* Vendida **por debajo** de lo estimado: es el caso que a nivel proyecto
       se compensa con el otro trato y deja de verse. */
    mercado: {
      precio_venta: { estimado: 60000, real: 56809.24, desvio: -3190.76 },
      horas: { estimado: 1200, real: null, desvio: null },
      costo_mo: { estimado: 23.33, real: null, desvio: null },
      costo_mo_total: { estimado: 28000, real: null, desvio: null },
      otros_costos: { estimado: 4000, real: null, desvio: null },
      margen: { estimado: 28000, real: 25909.24, desvio: -2090.76 },
      margen_porcentual: 46.7, margen_porcentual_real: 45.6
    },
    // Facturada entera, más una nota de débito por ajuste de precio
    facturado: 63419.49, pendiente: 0, excedente: 6610.25, por_notas_de_debito: 6610.25
  },
  {
    id: 2, armus_id: 502, numero: 'S00099', fecha_pedido: '2026-09-02',
    moneda: 'USD', monto_total: 68739.18, monto_neto: 56809.24,
    monto_original: 85941118.52, moneda_original: 'ARS',
    cliente: 'ACME SA', estado: 'sale',
    oportunidad_codigo: '144', oportunidad_nombre: 'Ampliación',
    // Vendida **por encima** de lo estimado
    mercado: {
      precio_venta: { estimado: 55000, real: 56809.24, desvio: 1809.24 },
      horas: { estimado: 1000, real: null, desvio: null },
      costo_mo: { estimado: 26, real: null, desvio: null },
      costo_mo_total: { estimado: 26000, real: null, desvio: null },
      otros_costos: { estimado: 3000, real: null, desvio: null },
      margen: { estimado: 26000, real: 27709.24, desvio: 1709.24 },
      margen_porcentual: 47.3, margen_porcentual_real: 48.8
    },
    // Facturó una parte y se anuló entera: queda en cero
    facturado: 0, pendiente: 56809.24, excedente: 0, por_notas_de_debito: 0
  }
];

const FACTURAS = [
  {
    fecha_vencimiento: '2026-09-02', condicion_pago: null, vencimiento_confiable: false, cobranza: 'in_payment', cobranza_legible: 'Pago en curso', saldo_original: 103988753.41, saldo_moneda: 'ARS', saldo: 83174.41,
    /* **`in_payment` sin fecha de cobro**: Odoo lo marca así en cuanto alguien
       registra un pago, con el saldo entero y nada conciliado. Es el caso que
       ARMUS nos pidió no confundir con cobrado. */
    fecha_cobro: null, cobros: 0, cobrado: false,
    id: 1, armus_id: 701, numero: 'FA-B 00001-00000001', tipo: 'factura',
    tipo_legible: 'Factura', documento_corregido: null, fecha_factura: '2026-09-02',
    moneda: 'USD', monto_total: 68739.18, monto_neto: 56809.24,
    monto_original: 85941118.52, moneda_original: 'ARS',
    cliente: 'ACME SA', estado: 'posted',
    origen: 'S00087', orden_numero: 'S00087', sin_orden: false, excede_orden: null
  },
  {
    fecha_vencimiento: '2026-10-15', condicion_pago: '30 días', vencimiento_confiable: true, cobranza: 'reversed', cobranza_legible: 'Anulado por nota de crédito', saldo_original: 0, saldo_moneda: 'ARS', saldo: 0,
    /* Saldada por una nota de crédito: concilia, pero no entró plata. */
    fecha_cobro: null, cobros: 0, cobrado: false,
    id: 2, armus_id: 702, numero: 'FA-B 00001-00000002', tipo: 'factura',
    tipo_legible: 'Factura', documento_corregido: null, fecha_factura: '2026-09-02',
    moneda: 'USD', monto_total: 20621.76, monto_neto: 17042.77,
    monto_original: 25782335.56, moneda_original: 'ARS',
    cliente: 'ACME SA', estado: 'posted',
    origen: 'S00099', orden_numero: 'S00099', sin_orden: false, excede_orden: null
  },
  {
    fecha_vencimiento: '2026-09-02', condicion_pago: null, vencimiento_confiable: false, cobranza: 'paid', cobranza_legible: 'Pagado', saldo_original: 0, saldo_moneda: 'ARS', saldo: 0,
    fecha_cobro: null, cobros: 0, cobrado: false,
    id: 3, armus_id: 703, numero: 'NC-B 00001-00000001', tipo: 'nota_credito',
    tipo_legible: 'Nota de crédito', documento_corregido: 'FA-B 00001-00000002',
    fecha_factura: '2026-09-02',
    moneda: 'USD', monto_total: -20621.76, monto_neto: -17042.77,
    monto_original: -25782335.56, moneda_original: 'ARS',
    cliente: 'ACME SA', estado: 'posted',
    origen: 'S00099', orden_numero: 'S00099', sin_orden: false, excede_orden: null
  },
  {
    fecha_vencimiento: '2026-09-02', condicion_pago: null, vencimiento_confiable: false, cobranza: 'partial', cobranza_legible: 'Pago parcial', saldo_original: 4100000, saldo_moneda: 'ARS', saldo: 3280.16,
    /* Cobrada en dos veces: la fecha es la del último, y por eso va el conteo
       al lado. Sola se leería como si ese día hubiera entrado todo. */
    fecha_cobro: '2026-09-04', cobros: 2, cobrado: false,
    id: 4, armus_id: 704, numero: 'ND-B 00001-00000001', tipo: 'nota_debito',
    tipo_legible: 'Nota de débito', documento_corregido: 'FA-B 00001-00000001',
    fecha_factura: '2026-09-02',
    moneda: 'USD', monto_total: 8000.40, monto_neto: 6610.25,
    monto_original: 10000000, moneda_original: 'ARS',
    cliente: 'ACME SA', estado: 'posted',
    origen: 'S00087', orden_numero: 'S00087', sin_orden: false,
    // Esta ND es la que deja a S00087 por encima de lo vendido
    excede_orden: 6610.25, excede_moneda: 'USD'
  },
  {
    /* **El caso que ARMUS reprodujo en DEV**: tres cobros conciliados, saldo
       en cero, y Odoo la dejó igual en `in_payment`. Está acá para que se vea
       que la fila sale verde y dice «Pagado»: pintarla de ámbar mandaría a
       reclamar plata que ya entró. Es el reverso exacto de la primera, que
       está en el mismo estado y no cobró nada. */
    fecha_vencimiento: '2026-09-30', condicion_pago: '30 días', vencimiento_confiable: true, cobranza: 'in_payment', cobranza_legible: 'Pagado', saldo_original: 0, saldo_moneda: 'ARS', saldo: 0,
    fecha_cobro: '2026-09-01', cobros: 3, cobrado: true,
    id: 5, armus_id: 705, numero: 'FA-B 00001-00000003', tipo: 'factura',
    tipo_legible: 'Factura', documento_corregido: null, fecha_factura: '2026-09-01',
    moneda: 'USD', monto_total: 6050, monto_neto: 5000,
    monto_original: 7623000, moneda_original: 'ARS',
    cliente: 'ACME SA', estado: 'posted',
    origen: 'S00087', orden_numero: 'S00087', sin_orden: false, excede_orden: null
  }
];

const suma = (xs: number[]) => Math.round(xs.reduce((t, x) => t + x, 0) * 100) / 100;

/**
 * Devuelve **el cuerpo**, no un `HttpResponse`: el interceptor lo envuelve él.
 * Devolver la respuesta ya armada la anida dentro de otra y el componente
 * recibe el sobre en vez de la carta —sin error, con la lista vacía—.
 */
export function respuestaVentas(
  metodo: string,
  ruta: string,
  params?: URLSearchParams
): unknown | null {
  if (metodo !== 'GET') return null;

  /* Los indicadores de todo el portafolio, **calculados de los mismos
     proyectos que muestra la tabla**. Antes eran ocho números fijos: filtrar
     por una empresa dejaba las tarjetas quietas, y el demo enseñaba que los
     filtros no las tocan, que es justo lo contrario de lo que hace la app. */
  if (/\/api\/indicadores\/?$/.test(ruta)) {
    return indicadoresDelPortafolio(params);
  }

  /* Los indicadores de la cabecera. Cada uno sale de la fuente que lo detalla,
     así que tienen que cerrar con las pestañas: la venta con Órdenes, los
     ingresos con Facturación, los gastos con Costos. */
  if (/\/api\/project\/[^/]+\/indicadores\/?$/.test(ruta)) {
    return {
      success: true,
      moneda: 'USD',
      venta_total: 113618.48,
      ingresos: 63419.49,
      gastos: 232150.75,
      margen: -168731.26,
      /* Sobre la venta: -168.731,26 / 113.618,48. */
      margen_porcentual: -148.51,
      /* Lo que se estimó al vender. Muy por encima del real, así que la
         tarjeta tiene que salir en rojo. */
      margen_estimado: 22.5,
      horas_vendidas: 2400,
      /* Lo producido sale de las imputaciones, con los estados separados. El
         total son las dos primeras: fuera de plan son esas mismas horas
         marcadas, así que no se suma. */
      horas_producidas: 2540,
      horas_aprobadas: 2180,
      horas_sin_aprobar: 360,
      horas_fuera_de_plan: 195,
      horas_certificadas: 860,
      horas_certificadas_regularizacion: 540,
      /* Este proyecto certifica por horas, no por hito. */
      porcentaje_certificado: null,
      /* Negativo a propósito: se trabajaron 140 horas más de las vendidas, que
         es el caso que la tarjeta tiene que pintar en rojo. */
      horas_pendientes: -140
    };
  }

  /* Las personas del cliente que todavía no están en el proyecto: es lo que
     ofrece el desplegable de la tabla de contactos, con buscador. Van varias a
     propósito, para poder ver el buscador aparecer. */
  if (/\/api\/project\/[^/]+\/cliente\/contactos-disponibles\/?$/.test(ruta)) {
    return {
      success: true,
      data: [
        { id: 501, name: 'Sofía Ledesma', email: 'sledesma@cliente.com', telefono: '+54 9 11 5555-0101', funcion: 'Gerenta de Compras', origen: 'armus' },
        { id: 502, name: 'Ramiro Cáceres', email: 'rcaceres@cliente.com', telefono: null, funcion: 'Jefe de Sistemas', origen: 'armus' },
        { id: 503, name: 'Ana Belén Ortiz', email: 'aortiz@cliente.com', telefono: '+54 9 11 5555-0103', funcion: 'Analista de Procesos', origen: 'armus' },
        { id: 504, name: 'Gonzalo Peralta', email: 'gperalta@cliente.com', telefono: null, funcion: 'Contador', origen: 'evoluciona' },
        { id: 505, name: 'Malena Ruiz Díaz', email: 'mruizdiaz@cliente.com', telefono: '+54 9 11 5555-0105', funcion: 'Responsable de Calidad', origen: 'armus' },
        { id: 506, name: 'Ignacio Vera', email: 'ivera@cliente.com', telefono: null, funcion: 'Compras', origen: 'armus' },
        { id: 507, name: 'Carla Benítez', email: 'cbenitez@cliente.com', telefono: null, funcion: 'RRHH', origen: 'armus' },
        { id: 508, name: 'Tomás Iglesias', email: 'tiglesias@cliente.com', telefono: null, funcion: 'Legales', origen: 'armus' },
        { id: 509, name: 'Paula Sosa', email: 'psosa@cliente.com', telefono: null, funcion: 'Tesorería', origen: 'armus' }
      ]
    };
  }

  /* A quién se puede asignar como responsable y con qué rol. Las personas son
     usuarios del sistema: el rol da acceso al proyecto. */
  if (/\/api\/project\/[^/]+\/asignables\/?$/.test(ruta)) {
    return {
      success: true,
      data: [
        { id_odoo: 201, name: 'Emilce Maidana', email: 'emaidana@vippinn.com' },
        { id_odoo: 202, name: 'Matías Salto', email: 'msalto@vippinn.com' },
        { id_odoo: 203, name: 'Valentina Merlo', email: 'vmerlo@vippinn.com' },
        { id_odoo: 204, name: 'Facundo Aguirre', email: 'feaguirre@vippinn.com' }
      ],
      /* Los seis roles reales. Invitado es el único que admite varias
         personas y el único de solo lectura. */
      roles: [
        /* Los dos de ARMUS también se eligen acá: existen de los dos lados y
           el cambio viaja al guardar. */
        { id: 1, code: 'gerente_proyecto', description: 'Gerente de Proyecto', desde_armus: true, solo_lectura: false, multiple: false },
        { id: 2, code: 'responsable_mercado', description: 'Responsable de Mercado', desde_armus: true, solo_lectura: false, multiple: false },
        { id: 3, code: 'lider_tecnico', description: 'Líder Técnico', solo_lectura: false, multiple: false },
        { id: 4, code: 'service_manager', description: 'Service Manager', solo_lectura: false, multiple: false },
        { id: 5, code: 'project_manager', description: 'Project Manager', solo_lectura: false, multiple: false },
        { id: 6, code: 'invitado', description: 'Invitado', solo_lectura: true, multiple: true }
      ],
      /* Service Manager ya lo tiene alguien: no tiene que aparecer para
         elegir, salvo en la fila que lo ocupa. */
      ocupados: [4]
    };
  }

  /* El estado del proyecto y lo que le falta para moverse.

     Es la respuesta real que manda ARMUS, con los dos requisitos que existen y
     que se dibujan distinto: uno bloquea y el otro sólo avisa. Están puestos
     sobre `en_curso`, que **no es un destino alcanzable desde En Curso**, para
     que se vea que un requisito de una transición no toca a las otras: los
     cuatro botones tienen que seguir vivos. */
  if (/\/api\/project\/[^/]+\/estado\/?$/.test(ruta)) {
    return {
      success: true,
      actual: { id_odoo: 2, codigo: 'en_curso', description: 'En Curso' },
      estados_disponibles: ['en_pausa', 'replanificacion', 'finalizaso', 'cancelado'],
      requisitos_pendientes: [
        {
          codigo: 'edt_debe_viajar',
          bloqueante: false,
          transiciones_afectadas: ['finalizaso'],
          detalle: 'Al salir de este estado la EDT se le avisa a Evoluciona, y si no llega el cambio no se guarda.'
        },
        {
          codigo: 'sin_orden_de_venta',
          bloqueante: true,
          transiciones_afectadas: ['cancelado'],
          detalle: 'Es de un plan productivo y no tiene ninguna orden de venta asociada.'
        }
      ],
      requisitos_sin_consultar: null
    };
  }

  /* La distribución de costos por componente. Los importes salen de las hojas
     de gasto del EDT de SEED01, con un componente que ARMUS imputa y todavía
     no mandó al catálogo y una línea sin componente asignado: los dos casos
     que la pantalla tiene que saber mostrar sin descartarlos. */
  if (/\/api\/project\/[^/]+\/costos\/distribucion\/?$/.test(ruta)) {
    const grupos = [
      { componente_id: 7, nombre: 'Mano de obra directa', conocido: true, real: 128400, presupuesto: 140000, lineas: 6 },
      { componente_id: 8, nombre: 'Subcontratos', conocido: true, real: 61250.5, presupuesto: 70000, lineas: 3 },
      { componente_id: 12, nombre: 'Licencias y software', conocido: true, real: 24980, presupuesto: 22000, lineas: 2 },
      { componente_id: 21, nombre: 'Viáticos y traslados', conocido: true, real: 9310.75, presupuesto: 12000, lineas: 4 },
      { componente_id: 44, nombre: 'Componente #44', conocido: false, real: 5120, presupuesto: 0, lineas: 1 },
      { componente_id: null, nombre: 'Sin componente de costo', conocido: true, real: 3140.25, presupuesto: 4000, lineas: 2 }
    ];
    const total = suma(grupos.map((g) => g.real));

    return {
      success: true,
      moneda: 'USD',
      total,
      data: grupos.map((g) => ({
        ...g,
        porcentaje: Math.round((g.real / total) * 10000) / 100
      })),
      sin_clasificar: { lineas: 2, real: 8400 },
      ingreso_excluido: 0
    };
  }

  if (/\/api\/project\/[^/]+\/ordenes-venta\/?$/.test(ruta)) {
    return {
      success: true,
      moneda: 'USD',
      base_comparacion: 'neto',
      totales: {
        ordenes: ORDENES.length,
        monto_total: suma(ORDENES.map((o) => o.monto_total)),
        monto_neto: suma(ORDENES.map((o) => o.monto_neto)),
        facturado: suma(ORDENES.map((o) => o.facturado)),
        pendiente: suma(ORDENES.map((o) => o.pendiente)),
        facturado_sin_orden: 0
      },
      data: ORDENES
    };
  }

  if (/\/api\/project\/[^/]+\/facturas\/?$/.test(ruta)) {
    return {
      success: true,
      moneda: 'USD',
      base_comparacion: 'neto',
      incluye: ['factura', 'nota_credito', 'nota_debito'],
      totales: {
        facturas: FACTURAS.length,
        facturado: suma(FACTURAS.map((f) => f.monto_neto)),
        facturado_bruto: suma(FACTURAS.map((f) => f.monto_total)),
        /* Lo cobrado y lo pendiente, en la moneda del reporte. Uno de los
           comprobantes queda sin saldo convertible a propósito, para ver que
           la tarjeta lo diga en vez de que la suma no cierre y parezca un
           error de cuentas. */
        abonado: 51497.39,
        adeudado: 17972.10,
        /* Los mismos dos sin impuestos: la proporción neta/bruta del conjunto
           es 0,826, la misma que sale de los comprobantes de arriba. */
        abonado_neto: 42537.24,
        adeudado_neto: 14844.96,
        sin_proporcion: 0,
        sin_saldo: 0
      },
      data: FACTURAS
    };
  }

  return null;
}


/**
 * Los indicadores del portafolio, sumados de los proyectos que quedan.
 *
 * Los proyectos que muestra la tabla, como el backend (2/11/2026).
 */
function indicadoresDelPortafolio(params?: URLSearchParams): unknown {
  // Los que muestra la tabla (2/11/2026)
  const ids = new Set((params?.get('ids') ?? '').split(',').filter(Boolean).map(Number));
  const elegidos = PROYECTOS_DEMO.filter((p) => ids.has(p.id));

  const suma = (leer: (p: (typeof PROYECTOS_DEMO)[number]) => number) =>
    Math.round(elegidos.reduce((s, p) => s + (leer(p) || 0), 0) * 100) / 100;

  const venta = suma((p) => Number(p.venta_real ?? 0));
  const ingresos = suma((p) => Number(p.ingresos_reales ?? 0));
  const gastos = suma((p) => Number(p.costos_reales ?? 0));
  const margen = Math.round((ingresos - gastos) * 100) / 100;

  /* El estimado del conjunto **no es el promedio de los porcentajes**: es la
     suma de los márgenes estimados sobre la suma de las ventas estimadas. */
  const ventaEstimada = suma((p) => Number(p.total_selling_price ?? 0));
  const margenEstimado = suma(
    (p) => (Number(p.total_selling_price ?? 0) * Number(p.market_margin_percentage ?? 0)) / 100
  );

  const horasVendidas = suma((p) => Number(p.sold_hours ?? 0));

  /* Lo trabajado. En el demo no hay imputaciones por proyecto en esta lista,
     así que se toma una proporción fija de lo vendido —el 40%, con un cuarto
     de eso todavía sin aprobar—: alcanza para ver la composición y sus
     colores, y las tres cifras cierran entre sí. */
  const producidas = Math.round(horasVendidas * 0.4 * 10) / 10;
  const sinAprobar = Math.round(producidas * 0.25 * 10) / 10;

  return {
    success: true,
    moneda: 'USD',
    alcance: 'en_curso',
    proyectos: elegidos.length,
    venta_total: venta,
    ingresos,
    gastos,
    margen,
    margen_porcentual: venta > 0 ? Math.round((margen / venta) * 10000) / 100 : null,
    margen_estimado: ventaEstimada > 0
      ? Math.round((margenEstimado / ventaEstimada) * 10000) / 100
      : null,
    horas_vendidas: horasVendidas || null,
    horas_producidas: producidas || null,
    horas_aprobadas: Math.round((producidas - sinAprobar) * 10) / 10,
    horas_sin_aprobar: sinAprobar,
    horas_fuera_de_plan: Math.round(producidas * 0.05 * 10) / 10,
    horas_certificadas: Math.round(producidas * 0.8 * 10) / 10,
    horas_certificadas_regularizacion: Math.round(producidas * 0.5 * 10) / 10,
    horas_pendientes: horasVendidas > 0
      ? Math.round((horasVendidas - producidas) * 10) / 10
      : null
,
    horas_excedidas: 10733,
    proyectos_excedidos: 9,
    horas_disponibles: 6246,
    proyectos_con_disponibles: 8,
    horas_sin_vendidas: 908
  };
}
